import { api } from '../api/endpoints.js';
import { haptic } from '../tg.js';

// Referral bottom sheet — share code + earn stars.
// Layout:
//   header: INVITE FRIENDS · "Earn +N⭐ for every friend"
//   reward stat: bonus per invite + total invited so far
//   code chip: tap to copy
//   primary CTA: Share via Telegram
//   recent invites list (last 10)
export function openReferralSheet(parent) {
  return new Promise((resolve) => {
    const el = document.createElement('div');
    el.className = 'modal-overlay sheet-overlay';
    el.innerHTML = `
      <div class="sheet sheet-ref">
        <div class="sheet-handle"></div>
        <div class="sheet-header">
          <div class="sheet-title">INVITE FRIENDS</div>
          <div class="sheet-sub" id="ref-sub">Loading…</div>
        </div>
        <div class="sheet-body" id="ref-body">
          <div class="sheet-loading">Loading…</div>
        </div>
        <button class="sheet-close">Close</button>
      </div>`;
    parent.appendChild(el);

    const sheetEl = el.querySelector('.sheet');
    requestAnimationFrame(() => sheetEl.classList.add('show'));

    const close = () => {
      if (sheetEl.classList.contains('closing')) return;
      sheetEl.classList.add('closing');
      setTimeout(() => { el.remove(); resolve({ status: 'closed' }); }, 220);
    };

    el.querySelector('.sheet-close').onclick = close;
    el.onclick = (ev) => { if (ev.target === el) close(); };

    const sub = el.querySelector('#ref-sub');
    const body = el.querySelector('#ref-body');

    api.getReferralInfo().then((data) => {
      const code = data?.code || '';
      const link = data?.share_link || '';
      const shareText = data?.share_text || 'Join Beer Catch Party with me!';
      const bonus = data?.bonus_per_invite ?? 10;
      const total = data?.total_invited ?? 0;
      const invites = data?.recent_invites || [];

      sub.textContent = `Earn +${bonus}⭐ for every friend who joins via your link`;

      const invitesHTML = invites.length === 0
        ? '<div class="sheet-empty">No invites yet — share your link below</div>'
        : invites.map((u) => {
            const name = u.name || (u.username ? '@' + u.username : 'Player');
            return `<div class="ref-friend"><span class="ref-friend-icon">👤</span><span class="ref-friend-name">${escapeHtml(name)}</span><span class="ref-friend-bonus">+${bonus}⭐</span></div>`;
          }).join('');

      body.innerHTML = `
        <div class="ref-stats">
          <div class="ref-stat">
            <div class="ref-stat-v">${total}</div>
            <div class="ref-stat-l">INVITED</div>
          </div>
          <div class="ref-stat">
            <div class="ref-stat-v neon-gold">+${total * bonus}⭐</div>
            <div class="ref-stat-l">EARNED</div>
          </div>
        </div>

        <div class="ref-code-block">
          <div class="ref-code-label">YOUR CODE</div>
          <button class="ref-code-chip" id="ref-copy">
            <span class="ref-code-val">${code || '—'}</span>
            <span class="ref-code-icon">📋</span>
          </button>
        </div>

        <button class="btn-primary ref-share" id="ref-share" ${link ? '' : 'disabled'}>
          <span>${link ? 'SHARE ON TELEGRAM' : 'Share link unavailable'}</span>
        </button>

        <div class="ref-friends">
          <div class="ref-friends-header">RECENT INVITES</div>
          ${invitesHTML}
        </div>`;

      // Copy code to clipboard
      const copyBtn = el.querySelector('#ref-copy');
      copyBtn.onclick = async () => {
        haptic('selection');
        const text = code || link;
        if (!text) return;
        try {
          await navigator.clipboard.writeText(text);
          copyBtn.classList.add('copied');
          const orig = copyBtn.querySelector('.ref-code-icon').textContent;
          copyBtn.querySelector('.ref-code-icon').textContent = '✓';
          setTimeout(() => {
            copyBtn.classList.remove('copied');
            copyBtn.querySelector('.ref-code-icon').textContent = orig;
          }, 1500);
        } catch {
          // Fallback: select-text trick (older browsers)
          const r = document.createRange();
          r.selectNode(copyBtn.querySelector('.ref-code-val'));
          window.getSelection().removeAllRanges();
          window.getSelection().addRange(r);
        }
      };

      // Share via Telegram share dialog
      const shareBtn = el.querySelector('#ref-share');
      if (link) {
        shareBtn.onclick = () => {
          haptic('medium');
          const tg = window.Telegram?.WebApp;
          const shareUrl = `https://t.me/share/url?url=${encodeURIComponent(link)}&text=${encodeURIComponent(shareText)}`;
          if (tg?.openTelegramLink) {
            tg.openTelegramLink(shareUrl);
          } else {
            window.open(shareUrl, '_blank');
          }
        };
      }
    }).catch((e) => {
      haptic('error');
      body.innerHTML = `<div class="sheet-error">${e?.message || 'Failed to load'}</div>`;
    });
  });
}

function escapeHtml(s) {
  return String(s)
    .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
}
